module.exports = __webpack_public_path__ + "@/assets/img/cuenta_corriente.09c0bc81.png";